import { FaFacebook, FaLinkedin, FaTwitter, FaYoutube } from "react-icons/fa";
import mapoImg from "../../assets/w.png"
import "./footer.css"

function footer(){
    return (
        <>
        <div class="footer-area text-center footer-padding bg-222">
		<div class="container">
			<div class="row">
				<div class="col-md-12 mb-20px">
					<img alt="img" src={mapoImg}/>
				</div>
				<div class="col-md-12">
					<div class="social-icons">
						<a href="https://www.facebook.com/MapoSoftwareSolutions" class="color-bbb radius-50 mr-5px mb-10px color-fff-hvr bg-orange-hvr transition-3" target="_blank">
							<FaFacebook/>
						</a>
						<a href="https://twitter.com/maposouthafrica?lang=en" class="color-bbb radius-50 mr-5px mb-10px color-fff-hvr bg-orange-hvr transition-3" target="_blank">
							<FaTwitter/>
						</a>
						
						<a href="https://za.linkedin.com/company/mapo-software-solutions---pty-ltd-" class="color-bbb radius-50 mr-5px mb-10px color-fff-hvr bg-orange-hvr transition-3" target="_blank">
							<FaLinkedin/>
						</a>

						<a href="https://www.youtube.com/@mapointernational9212" class="color-bbb radius-50 mr-5px mb-10px color-fff-hvr bg-orange-hvr transition-3" target="_blank">
							<FaYoutube/>
						</a>
					</div>
				</div>
				<div class="col-md-12">
					<p class="mt-10px mb-0px color-eee">© 2019 
						<strong class="color-orange"> MAPO International</strong>
					</p>
				</div>
			</div>
		</div>
	</div>
        </>
    )
}
export default footer;